module.exports = __webpack_public_path__ + "static/media/MilanesaCuadrada.b637cbe7.jpg";